import { render, staticRenderFns } from "./adminRoom.vue?vue&type=template&id=0b8aa9c7&"
import script from "./adminRoom.vue?vue&type=script&lang=js&"
export * from "./adminRoom.vue?vue&type=script&lang=js&"
import style0 from "./adminRoom.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports